module.exports = __webpack_public_path__ + "img/Human_symbol_2.d9c5389e.png";